import * as dd from 'dingtalk-jsapi';
import Vue from 'vue';
// eslint-disable-next-line import/no-cycle
import { dingLogin, dingAppAuth } from '@/api/dingLogin';

// 获取钉钉Code
export const getDingCode = async (callBack = null, callFail = null) => {
    try {
        if (dd.env.platform !== 'notInDingTalk') {
            // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
            console.log('corpId>>>>>>>', window.$LoginInfo.getCorpId());
            const res = await dd.runtime.permission.requestAuthCode({
                corpId: window.$LoginInfo.getCorpId(),
            });
            if (res.code) {
                window.$LoginInfo.setDingCode(res.code);
                callBack && callBack(res);
            } else if (callFail) {
                callFail(res);
            }
        } else {
            Vue.prototype.$message.error('请在钉钉里面打开');
        }
    } catch (err) {
        console.log('getDingCode>>>>err>>>>>', err);
    }
};

// 获取用户信息
export const getUserInfoByCodeAccount = async (code = null, callBack = null, api = dingAppAuth, params = null) => {
    try {
        const data = { param: code };
        const res = await api(params || data);
        console.log('dingAppAuth>>>>>', res);
        if (res.code === 0) window.$LoginInfo.serUserInfo(res.data);
        console.log('获取用户信息内容LoginFun>>>>>', window.$LoginInfo.getUserInfo());
        if (callBack) callBack(res);
    } catch (err) {
        console.log('getUserInfoByCodeAccount报错err》》', err);
    }
};

export const getDingLogin = async (subApplicationId = '', callBack = null) => {
    try {
        const data = {
            dingUserId: window.$LoginInfo.getDingUserId(),
            subApplicationId,
        };
        console.log('请求dingLogin的请求参数>>>>>', data);
        const resLogin = await dingLogin(data);
        console.log('resLogin>>>>>>>>', resLogin);
        if (resLogin.code === 0) {
            window.$LoginInfo.setLogininfo(resLogin.data);
        }
        if (callBack) callBack(resLogin);
    } catch (err) {
        console.log('getDingLogin>>err>>>>>', err);
    }
};

// 获取token接口
export const getToken = async (subApplicationId, callBack = null) => {
    try {
        if (window.$LoginInfo.getDingUserId()) { // 如果dingUserId存在直接获取token
            await getDingLogin(subApplicationId, callBack);
            console.log('获取Token结束>>>>>');
            return;
        }
        console.log('进入获取token逻辑>>>');
        await getDingCode();
        console.log('获取code结束', window.$LoginInfo.dingCode);
        if (window.$LoginInfo.dingCode) {
            console.log('开始调用getUserInfoByCodeAccount>>>>>')
            await getUserInfoByCodeAccount(window.$LoginInfo.dingCode, async (userRes) => {
            }, dingAppAuth, { param: { appCode: 'todo_task', authCode: window.$LoginInfo.dingCode } });
            console.log('获取用户信息结束>>>>>>>>');
            await getDingLogin(subApplicationId, callBack);
        }
    } catch (err) {
        console.log('getToken>>>>err>>>>>', err);
    }
};
